import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import { capitalCase } from 'change-case'
import type { SyntheticEvent } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

type AutocompleteBaseProps = Omit<AutocompleteProps<any, boolean, boolean, boolean>, 'renderInput'>

type RHFAutocompleteProps = AutocompleteBaseProps & {
  name: string
  label?: string
  placeholder?: string
  helperText?: React.ReactNode
  variant?: TextFieldProps['variant']
  required?: TextFieldProps['required']
  onChangeCallback?: (event: SyntheticEvent, value: any) => void
}

export function RHFAutocomplete({ name, label, variant, helperText, placeholder, onChangeCallback, required, getOptionLabel, ...other }: RHFAutocompleteProps) {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          {...field}
          getOptionLabel={option => (getOptionLabel ? getOptionLabel(option) : defaultGetOptionLabel(option))}
          onChange={(event, value) => {
            field?.onChange(value)
            onChangeCallback?.(event, value)
          }}
          renderInput={params => {
            // console.log(`RHFAutoComplete - name: ${name} - field: `, field, ` | renderInput params: `, params, ' | other: ', other)

            return (
              <TextField
                {...params}
                label={label}
                placeholder={placeholder}
                variant={variant}
                error={!!error}
                helperText={error ? error?.message : helperText}
                required={required}
                inputProps={{ ...params?.inputProps, autoComplete: 'new-password' }}
                InputProps={{ ...params?.InputProps }}
              />
            )
          }}
          {...other}
          size={other?.size ?? 'small'}
          options={other?.options || []}
        />
      )}
    />
  )
}

const defaultGetOptionLabel = (option: any) => {
  let label: string

  try {
    if (option?.name) {
      label = option?.name
    } else if (option?.label) {
      label = option?.label
    } else {
      label = option
    }
  } catch (e) {
    label = 'error formatting label'
  }

  return capitalCase(label) as string
}
